import { useEffect, useCallback } from "react";

interface UseKeyboardShortcutOptions {
  key: string;
  ctrlKey?: boolean;
  metaKey?: boolean;
  callback: () => void;
  enabled?: boolean;
}

export function useKeyboardShortcut({
  key,
  ctrlKey = false,
  metaKey = false,
  callback,
  enabled = true,
}: UseKeyboardShortcutOptions) {
  const handleKeyDown = useCallback(
    (event: KeyboardEvent) => {
      if (!enabled) return;

      const isCtrlOrMeta = ctrlKey || metaKey;
      const modifierPressed = event.ctrlKey || event.metaKey;

      if (
        event.key.toLowerCase() === key.toLowerCase() &&
        (!isCtrlOrMeta || modifierPressed)
      ) {
        event.preventDefault();
        callback();
      }
    },
    [key, ctrlKey, metaKey, callback, enabled]
  );

  useEffect(() => {
    document.addEventListener("keydown", handleKeyDown);
    return () => document.removeEventListener("keydown", handleKeyDown);
  }, [handleKeyDown]);
}

export function useSearchShortcut(callback: () => void, enabled = true) {
  useKeyboardShortcut({
    key: "k",
    ctrlKey: true,
    metaKey: true,
    callback,
    enabled,
  });
}
